import { useLanguage } from '../context/LanguageContext';

const LanguageToggle = () => {
  const { language, toggleLanguage } = useLanguage();

  return (
    <button
      onClick={toggleLanguage}
      className="flex items-center space-x-2 hover:text-indigo-200 transition-colors duration-200"
      title={language === 'en' ? 'Switch to Italian' : 'Passa all\'inglese'}
    >
      {language === 'en' ? (
        <>
          <span className="text-lg">🇮🇹</span>
          <span className="hidden sm:inline">IT</span>
        </>
      ) : (
        <>
          <span className="text-lg">🇺🇸</span>
          <span className="hidden sm:inline">EN</span>
        </>
      )}
    </button>
  );
};

export default LanguageToggle;